<template lang="pug">
  .content
    .content__block.ql-editor(
      v-html="program.text"
    )
</template>

<script>

export default {
  name: "ShiftProgram",
  props: {
    program: {
      type: Object,
      default: () => ({})
    }
  }

};
</script>
